import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AlgeriaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14618'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14618)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H10.4762V0H0V14Z'
					fill='#048345'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3813 7.72797L11.2617 8.51013L11.6748 7.22493L10.5698 6.42314L11.9447 6.411L12.3813 5.1333L12.818 6.411L14.1929 6.42314L13.0878 7.22493L13.5009 8.51013L12.3813 7.72797Z'
					fill='#E81B42'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.6291 10.067C11.8948 10.7698 10.9078 11.2 9.82263 11.2C7.55396 11.2 5.71484 9.31965 5.71484 7.00005C5.71484 4.68045 7.55396 2.80005 9.82263 2.80005C10.9078 2.80005 11.8948 3.23032 12.6291 3.93312C12.1226 3.69684 11.5497 3.56368 10.9429 3.56368C8.88051 3.56368 7.20858 5.1022 7.20858 7.00005C7.20858 8.8979 8.88051 10.4364 10.9429 10.4364C11.5497 10.4364 12.1226 10.3033 12.6291 10.067Z'
					fill='#E81B42'
				/>
			</g>
		</svg>
	);
};

export default AlgeriaFlagIcon;
